import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { BaseListDomainService } from '@common/domain/base-list-domain.service';
import { SearchResult, BackAuthEntitySearchResult } from '@common/models/search-result';

import { Entity } from './models/back/entity';
import { EntityApi } from '../api/models/back/entity-api';
import { EntitiesListApiService } from '../api/entities-list-api.service';

@Injectable({
    providedIn: 'root'
})
export class EntitiesListService extends BaseListDomainService
{
    constructor (
        private entitiesListApiService: EntitiesListApiService
    )
    {
        super();
    }

    getEntities (qs: string): Observable<Entity[]>
    {
        return this.entitiesListApiService
            .getEntities(qs)
            .pipe(
                map((obj: any): EntityApi[] =>
                    obj.value
                ),
                switchMap((entities: EntityApi[]) =>
                    this.mapEntitiesFromApi(entities)
                )
            );

        // if (!qs.includes('external=true'))
        // {
        //     return entities;
        // }
        // else
        // {
        //     return entities
        //         .pipe(
        //             withLatestFrom(this.departmentMiscDomainService.getEntities()),
        //             map(([entities, departments]) =>
        //             {
        //                 const existing = entities.map(e => e.name);
        //                 const toCreate: Entity[] = departments
        //                     .filter(d => !existing.includes(d.name))
        //                     .map(d =>
        //                         ({
        //                             active:true,
        //                             name: d.name,
        //                             entityShortId: d.entityShortId,
        //                             nbUsers: 0,
        //                             isVirtual: true,
        //                             external: true,
        //                             statusKey: BackConstants.getStatusKey(true),
        //                             statusClass: BackConstants.getCssStatus(true)
        //                         } as Entity)
        //                     );

        //                 return entities.concat(toCreate).sort((a, b) => a.name.localeCompare(b.name));
        //             })
        //         );
        // }
    }

    searchEntities (qs: string): Observable<SearchResult<Entity>[]>
    {
        return this.entitiesListApiService.searchEntities(qs)
            .pipe(
                map((obj: any): EntityApi[] =>
                    obj.value
                ),
                switchMap((entities: EntityApi[]) =>
                    this.mapEntitiesFromApi(entities)
                        .pipe(
                            map((mappedEntities: Entity[]) =>
                                mappedEntities
                                    .map(entity => new BackAuthEntitySearchResult(entity))
                                    .slice(0, 7)
                            )
                        )
                )
            );
    }

    private mapEntitiesFromApi (entities: EntityApi[]): Observable<Entity[]>
    {
        return of(
            entities.map((entityApi: EntityApi) => Entity.mapperFromApi(entityApi))
        );
    }
}
